import { useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
import { Undo2 } from 'lucide-react'
import { subscribeUndoToasts, getUndoToasts, undoToast } from './undoableAction'

/**
 * Renderiza os toasts de "Desfazer" criados por undoableAction (SZ-1589).
 * Montado junto de <FlashMessages/> nos layouts principais; os toasts ficam na
 * base da tela para não disputar com os flashes (topo). Renderiza null quando
 * não há ação pendente.
 */
export default function UndoToastHost() {
  const toasts = useSyncExternalStore(subscribeUndoToasts, getUndoToasts, getUndoToasts)

  if (toasts.length === 0) return null

  return createPortal(
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-[100] flex flex-col items-center gap-2 px-4">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          data-testid="undo-toast"
          className="pointer-events-auto flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-2.5 text-card-foreground shadow-lg"
        >
          <span className="text-sm">{toast.message}</span>
          <button
            type="button"
            onClick={() => undoToast(toast.id)}
            className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-sm font-medium text-primary transition-colors hover:bg-accent"
          >
            <Undo2 className="h-3.5 w-3.5" />
            {toast.undoLabel}
          </button>
        </div>
      ))}
    </div>,
    document.body,
  )
}
